import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { DEPARTEMENTS } from '../data/departements';

const SITE = 'https://www.locationbennechantier.com';
const DEFAULT_DESC = 'Location Benne Chantier : louez votre benne de chantier en ligne dès 245€ HT. Livraison rapide en Ile-de-France, devis instantané, paiement sécurisé. Bennes 3m³ à 30m³.';

const PAGES = {
  '/': {
    title: 'Location Benne Chantier - Location de Bennes BTP en Ile-de-France | Dès 245€',
    description: DEFAULT_DESC,
  },
  '/commander': {
    title: 'Commander une Benne en Ligne - Devis Instantané | Location Benne Chantier',
    description: 'Commandez votre benne de chantier en ligne en quelques clics : choisissez le volume (3 à 30m³), le type de déchets et votre date de livraison en Ile-de-France.',
  },
  '/commander-sans-compte': {
    title: 'Commander une Benne sans Compte - Paiement Sécurisé | Location Benne Chantier',
    description: 'Louez une benne de chantier sans créer de compte : devis immédiat, paiement par carte sécurisé et livraison sous 24h partout en Ile-de-France.',
  },
  '/inscription': {
    title: 'Créer un Compte - Location Benne Chantier',
    description: 'Créez votre compte professionnel ou particulier pour commander vos bennes de chantier, suivre vos livraisons et retrouver vos factures.',
  },
  '/connexion': {
    title: 'Connexion à votre Espace Client - Location Benne Chantier',
    description: 'Connectez-vous à votre espace client Location Benne Chantier pour gérer vos commandes de bennes et vos factures.',
  },
  ...Object.fromEntries(DEPARTEMENTS.map((d) => [d.path, { title: d.title, description: d.description }])),
};

const setMeta = (selector, attr, value) => {
  const el = document.head.querySelector(selector);
  if (el) el.setAttribute(attr, value);
};

const setCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!href) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
};

export const RouteSEO = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const path = pathname !== '/' && pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;
    const page = PAGES[path];

    if (!page) {
      document.title = 'Location Benne Chantier';
      setMeta('meta[name="robots"]', 'content', 'noindex, nofollow');
      setCanonical(null);
      return;
    }

    const canonical = `${SITE}${path}`;
    document.title = page.title;
    setMeta('meta[name="robots"]', 'content', 'index, follow');
    setMeta('meta[name="description"]', 'content', page.description);
    setCanonical(canonical);
    setMeta('meta[property="og:url"]', 'content', canonical);
    setMeta('meta[property="og:title"]', 'content', page.title);
    setMeta('meta[property="og:description"]', 'content', page.description);
    setMeta('meta[name="twitter:title"]', 'content', page.title);
    setMeta('meta[name="twitter:description"]', 'content', page.description);
  }, [pathname]);

  return null;
};
